import React, { useState } from 'react';
import { Tag, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import InputTooltip from 'components/InputInfoCircle';

import './tag-group.less';

const TagGroup = ({
  tags,
  onChange,
  inputWidth = 150,
  newTagLabel = 'Add tag',
  inputTooltip = 'Press Enter to add or Esc to cancel.',
}) => {
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      onChange([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue('');
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 27 /* Esc */) {
      setInputVisible(false);
    }
  };

  const handleRemove = (tagToRemove) => {
    const filtered = tags.filter(tag => tag !== tagToRemove);
    onChange(filtered);
  };

  return (
    <div className="tag-group">
      {tags.map(tag => (
        <Tag closable key={tag} onClose={() => handleRemove(tag)}>{tag}</Tag>
      ))}
      {inputVisible && (
        <Input
          style={{ width: inputWidth }}
          ref={input => input && input.focus()}
          type="text"
          size="small"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onPressEnter={handleInputConfirm}
          onKeyDown={handleKeyDown}
          suffix={inputTooltip && (<InputTooltip title={inputTooltip} />)}
        />
      )}
      {!inputVisible && (
        <Tag className="add-tag" onClick={showInput}>
          <PlusOutlined type="plus" />
          {' '}
          {newTagLabel}
        </Tag>
      )}
    </div>
  );
};

export default TagGroup;
